<template>
	<div v-if="active_study" class="print">
		<div class="pages">
			<page name="garde" class="printing" v-if="active_study.segment.code != 'GIE' && active_study.segment.code != 'SCPI'" />
			<page
				v-for="(section, index) in sections"
				:name="section.slug"
				:index="index + 1"
				:key="'pages-' + section.slug"
				class="printing"
			/>
		</div>
		<div class="actions">
			<div class="action">
				<div class="button blue" @click="print()">
					<div class="button-icon"><icon file="printer" :size="32" /></div>
					Imprimer l'étude en pdf
				</div>
				<div class="no">1</div>
				<div class="help">
					<icon file="help-circle" />
					<div class="tooltip">
						<p>Paramètres d'impression Chrome :</p>
						<img src="@/assets/img/print-help.png">
					</div>
				</div>
			</div>
			<template v-if="active_study.segment.code !== 'SCPI'">
				<div class="action-separator"><icon file="arrow-down" :size="40" /></div>
				<div class="action">
					<form action="" class="upload" :class="{green: uploaded}">
						<p v-if="!uploaded" class="tooltip">Glisser l'étude ici<br>pour la publier</p>
						<p v-if="uploaded" class="tooltip">PDF reçu !<br>vous pouvez fermer cette fenêtre</p>
						<div class="dropbox" @drop.prevent="addFile" @dragover.prevent @click="show_upload_box()">
								<input type="file" ref="upload_box" @change="handle_file_upload();">
						</div>
					</form>

					<div v-show="uploading" class="loading_box">
						<div class="loading"><icon file="loader" :size="32" /></div>
					</div>

					<div class="no">2</div>
				</div>
			</template>
			<div v-if="!print_help_visible" class="chrome-help-action" @click="show_print_help(true)"><icon file="help-circle" :size="24" /> Comment imprimer en pdf ?</div>
			<div v-else class="chrome-help">
				<icon file="help-circle" :size="24" />
				<div class="chrome-help-content">
					<p class="title">Comment imprimer en pdf ?</p>
					<p>Cliquer sur le bouton bleu ci-dessus "Imprimer l'étude en PDF".</p>
					<p>Dans la fenêtre qui apparaît, le panneau de gauche permet de modifier les paramètres d'impression.</p>
					<p>Choisir la destination à "<strong>Enregistrer au format pdf</strong>", puis renseigner les paramètres supplémentaires suivants :</p>
					<ul>
						<li><span class="label">Pages</span> : Tous</li>
						<li><span class="label">Mise en page</span> : Portrait</li>
						<li><span class="label">Taille du papier</span> : A4</li>
						<li><span class="label">Pages par feuilles</span> : 1</li>
						<li><span class="label">Marges</span> : Aucun</li>
						<li><span class="label">Mise à l'échelle</span> : Par défaut</li>
						<li><span class="label">Graphiques d'arrière-plan</span> : Oui</li>
					</ul>
					<p>Enfin, cliquer sur le bouton bleu "<strong>Enregistrer</strong>".</p>
					<div class="buttons"><div class="button" @click="show_print_help(false)">J'ai compris</div></div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";
import Page from "@/components/study/editor/page";
import StudyMixin from "@/components/study/study.mixin.js";
export default {
	name: "study",
	mixins: [StudyMixin],
	data: function () {
		return {
			uploading: false,
			uploaded: false,
			study_file: "",
			print_help_visible: true,
		};
	},
	computed: {
		...mapGetters([ "app", "study", "editor", "active_study" ]),
	},
	methods: {
		print: function () {
			window.print();
		},
		show_print_help: function (value) {
			this.print_help_visible = value;
			localStorage.setItem("lli-print-help-visible", value);
		},

		// === pdf upload ===
		addFile (e) {
			// console.log('add study file (drag/drop)');
			const droppedFiles = e.dataTransfer.files;
			if(!droppedFiles) return;
			this.study_file = droppedFiles[0];
			this.upload_file();
		},
		show_upload_box: function () {
			$(this.$refs.upload_box).click();
		},
		handle_file_upload: function () {
			// console.log('handle study pdf file upload (user clicked on upload zone)');
			const input = this.$refs.upload_box;
			if (input.files && input.files[0]) {
				this.study_file = input.files[0];
				this.upload_file();
			}
		},
		async upload_file () {
			this.uploading = true;
			this.uploaded = false;
			try {
				await this.$store.dispatch("upload_file", { the_file: this.study_file, parent_data: this.active_study, property: "pdfLien" });
				// console.log('uploaded, saving');
				//Set required +1
				await this.$store.dispatch("save_study");
				//force saving
				await this.$store.dispatch("save_required");
				this.$router.push({ name: "study", params: { id: this.$route.params.id }});
			} catch (error) {
				console.error("ERROR while uploading pdf study", error);
			}
			this.uploading = false;
			this.uploaded = true;
		},

	},
	mounted: function () {
		this.$store.dispatch("set_mode", { mode: "viewing" });
		const visible = localStorage.getItem("lli-print-help-visible");
		if (!_.isNull(visible) && visible == "false")
			this.print_help_visible = false;
	},
	components: { Page }
};
</script>

<style lang="stylus">
@import '../../assets/css/app'


html, body, #app, .main
	height 100%
	overflow visible
	
.print
	overflow auto
	padding-right (250px + 24px)
	.page
		margin 16px auto
	.actions
		position fixed
		right 24px
		top 24px
		bottom 24px
		width 250px
		z-index 10000
		.action
			.no
				position absolute
				top calc(50% - 20px)
				left -24px
				width 40px
				height 40px
				background-color light
				border-radius 50%
				text-align center
				font-weight 500
				line-height @height
				font-size 18px
				box-shadow 0 0 0 4px dark
			.button
				display block
				// height 64px
				margin 0 0 16px 0
				padding 24px 0
				background-color #000
				border-radius radius
				line-height @height
				text-align center
				font-weight 500
				text-transform uppercase
				color #fff
				cursor pointer
				&.blue
					background-color blue
					&:hover
						background-color darken(blue, 15%)
				&:active
					transform translateY(1px)
				.button-icon
					margin 0 0 12px 0
					> .icon
						display block
						margin 0 auto
			.help
				position absolute
				right 0
				top 0
				color #fff
				padding 8px
				cursor help
				z-index 2
				opacity 0.5
				&:hover
					opacity 1
					.tooltip
						display block
				.tooltip
					display none
					position absolute
					right -2px
					top 40px
					background-color #fff
					border-radius radius
					box-shadow 0 0 4px #000
					padding 24px
					color dark
					font-weight 500
					p
						margin 0 0 8px 0
					img
						border 1px solid #ddd
						border-radius radius
					&:hover
						display none
			.upload
				.tooltip
					position absolute
					left 0
					right 0
					top 50%
					transform translateY(-50%)
					margin 0 0 16px 0
					padding 0 24px
					border-radius radius
					font-weight 500
					line-height 20px
					text-align center
					color light
					text-transform uppercase
					opacity 0.75
				.dropbox
					height @width
					border 2px dashed light
					border-radius radius
					background-color alpha(light, 5%)
					cursor pointer
					&:hover
						background-color alpha(light, 10%)
				&.green
					background-color green
					color white
					> .tooltip
						color white
					> .dropbox
						color white
						border none
					&:hover
						background-color darken(green, 15%)
					
				input
					position absolute
					top 0
					left 10000px
					opacity 0


		.action-separator
			margin 0 0 16px 0
			padding 8px 0
			color light
			text-align center
			line-height 24px
		.chrome-help-action
			position absolute
			right 0
			bottom -24px
			padding 8px 12px
			background-color light
			border-top-left-radius radius
			border-top-right-radius radius
			color dark
			line-height 24px
			white-space nowrap
			font-weight 500
			font-size 13px
			cursor pointer
			&:hover
				background-color darken(light, 10%)
			> .icon
				float left
				margin 0 8px 0 0
		.chrome-help
			position absolute
			right 0
			bottom 0
			width 450px
			background-color light
			padding 16px
			border-radius radius
			box-shadow 0 0 4px alpha(dark, 50%)
			font-size 13px
			> .icon
				position absolute
				left 16px
				top 16px
			.chrome-help-content
				margin-left 36px
				.title
					height 24px
					line-height 26px
					font-weight 500
					white-space nowrap
					text-transform uppercase
				p
					margin 0 0 8px 0
					&:last-child
						margin 0
				ul
					margin 0 0 8px 16px
					li
						padding 1px 0
						font-weight 500
						.label
							font-weight 400
				.buttons
					margin 16px 0 0 0
					text-align right
					.button
						display inline-block
						padding 12px 16px
						background-color green
						border-radius radius
						font-weight 500
						color dark
						cursor pointer
						&:hover
							background-color darken(green, 10%)
						&:active
							background-color darken(green, 20%)
							transform translateY(1px)

		
.pages
	padding 0
	display flex
	flex-direction column
	align-items center
	background-color dark
	.page
		margin 24px 0 0 0
		box-shadow none
		// &:last-child
		// 	margin-bottom 24px

.loading_box
	position absolute
	color light
	top 160px
	left 20px
	text-align center
	width 100%

.loading
	right 20px
	top 20px
	animation rotate 1s linear infinite
	color white


@keyframes rotate
	from
		transform rotate(0deg)
	to
		transform rotate(359deg)


@media print
	@page
		size 792px 1120px
	html, body
		width fit-content  !important
		height fit-content  !important
	body
		background-color #fff  !important
		line-height unset  !important
		print-color-adjust: exact  !important;
		-webkit-print-color-adjust: exact !important;
		color-adjust: exact !important;
		zoom 150%
	.print
		padding 0
		.pages
			.page
				contain strict
				margin 0 !important
				box-shadow none !important
		.actions
			display none !important

@-moz-document url-prefix()
	@media print
		html, body
			width fit-content  !important
			height fit-content  !important
		body
			background-color #fff  !important
			line-height unset  !important
			print-color-adjust: exact  !important;
			-webkit-print-color-adjust: exact !important;
			color-adjust: exact !important;
			font-weight: bold !important
		.print
			padding 0
			.pages
				.page
					// height 100vh !important
					// width: 100vw !important
					// heigt 1120px
					// width 792px
					margin 0 !important
					box-shadow none !important
			.actions
				display none !important

		
</style>